interface AssineChoiceState {
  choiceId: number
  choiceType: string
}
interface AssineChoicePlanTypeState {
  choicePlanTypeName: string
  choicePlanTypeId: number
}
export const assineChoiceStore = defineStore('assineChoice', {
  state: () => ({
    choiceId: 0 as number,
    choiceType: '' as string,
    choicePlanTypeName: '' as string,
    choicePlanTypeId: 0 as number,
    choiceTurboId: 0 as number,
    choiceName: '' as string,
  }),
  getters: {
    // Fonte única da verdade do tema dourado no fluxo de assinatura:
    // depende do plano ESCOLHIDO, não do plano que o usuário já possui.
    isGoldChoice: (state): boolean => state.choicePlanTypeName === 'Gold',
  },
  actions: {
    async setAssineChoice(payload: AssineChoiceState) {
      this.choiceId = payload.choiceId
      this.choiceType = payload.choiceType
    },
    async setAssineChoicePlanType(payload: AssineChoicePlanTypeState) {
      this.choicePlanTypeId = payload.choicePlanTypeId
      this.choicePlanTypeName = payload.choicePlanTypeName
    },
    async setAssineChoiceTurbo(id: number) {
      this.choiceTurboId = id
    },
    async setChoiceName(name: string) {
      this.choiceName = name
    }
  },
  persist: {
    key: 'assineChoice',
    storage: piniaPluginPersistedstate.sessionStorage()
  }
})
